module.exports = __webpack_public_path__ + "img/news 1.97e4fe75.svg";